enum ContactPersonClassificationTypes {
  None = 0, // eslint-disable-line no-unused-vars
  PrimaryContact = 1, // eslint-disable-line no-unused-vars
  SecondaryContact = 2, // eslint-disable-line no-unused-vars
}
export default ContactPersonClassificationTypes;
